"use strict";

/*!
   Copyright 2019 Ron Buckton

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
var _defineProperty = require("/usr/src/app/node_modules/@babel/runtime/helpers/defineProperty.js");
var _createClass = require("/usr/src/app/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/usr/src/app/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _inherits = require("/usr/src/app/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/usr/src/app/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/usr/src/app/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelableSource = exports.Cancelable = exports.CancelSubscription = exports.CancelError = void 0;
var disposable_1 = require("@esfx/disposable");
var CancelError = /*#__PURE__*/function (_Error) {
  _inherits(CancelError, _Error);
  var _super = _createSuper(CancelError);
  function CancelError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Operation was canceled";
    _classCallCheck(this, CancelError);
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return _super.call.apply(_super, [this, message].concat(args));
  }
  return _createClass(CancelError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.CancelError = CancelError;
_a = CancelError;
(function () {
  Object.defineProperty(_a.prototype, "name", {
    configurable: true,
    writable: true,
    value: "CancelError"
  });
})();
var CancelSubscription;
(function (CancelSubscription) {
  var CancelSubscriptionPrototype = _defineProperty({}, disposable_1.Disposable.dispose, function () {
    this.unsubscribe();
  });
  Object.defineProperty(CancelSubscriptionPrototype, Symbol.toStringTag, {
    configurable: true,
    value: "CancelSubscription"
  });
  /**
   * Creates a `CancelSubscription` object for an `unsubscribe` callback.
   * @param unsubscribe The callback to execute when the `unsubscribe()` method is called.
   */
  function create(_unsubscribe) {
    if (!(typeof _unsubscribe === "function")) throw new TypeError("Function expected: unsubscribe");
    return Object.setPrototypeOf({
      unsubscribe: function unsubscribe() {
        _unsubscribe();
      }
    }, CancelSubscriptionPrototype);
  }
  CancelSubscription.create = create;
})(CancelSubscription = exports.CancelSubscription || (exports.CancelSubscription = {}));
var Cancelable;
(function (Cancelable) {
  // #region Cancelable
  /**
   * A well-known symbol used to define a method to retrieve the `CancelSignal` for an object.
   */
  Cancelable.cancelSignal = Symbol.for("@esfx/cancelable:Cancelable.cancelSignal");
  // #endregion Cancelable
  var CancelSignalPrototype = _defineProperty({}, Cancelable.cancelSignal, function () {
    return this;
  });
  Object.defineProperty(CancelSignalPrototype, Symbol.toStringTag, {
    configurable: true,
    value: "CancelSignal"
  });
  var emptySubscription = CancelSubscription.create(function () {});
  Object.freeze(emptySubscription);
  var canceledReason = new CancelError();
  Object.freeze(canceledReason);
  /**
   * A `Cancelable` that is already signaled.
   */
  Cancelable.canceled = Object.setPrototypeOf({
    get signaled() {
      return true;
    },
    get reason() {
      return canceledReason;
    },
    subscribe: function subscribe(onSignaled) {
      if (!(typeof onSignaled === "function")) throw new TypeError("Function expected: onSignaled");
      onSignaled();
      return emptySubscription;
    }
  }, CancelSignalPrototype);
  Object.freeze(Cancelable.canceled);
  /**
   * A `Cancelable` that can never be signaled.
   */
  Cancelable.none = Object.setPrototypeOf({
    get signaled() {
      return false;
    },
    get reason() {
      return undefined;
    },
    subscribe: function subscribe(onSignaled) {
      if (!(typeof onSignaled === "function")) throw new TypeError("Function expected: onSignaled");
      return emptySubscription;
    }
  }, CancelSignalPrototype);
  Object.freeze(Cancelable.none);
  /**
   * Determines whether `cancelable` is in the signaled state.
   */
  function isSignaled(cancelable) {
    if (cancelable === null || cancelable === undefined) return false;
    if (!hasInstance(cancelable)) throw new TypeError("Cancelable expected: cancelable");
    if (cancelable === Cancelable.canceled) return true;
    if (cancelable === Cancelable.none) return false;
    return cancelable[Cancelable.cancelSignal]().signaled;
  }
  Cancelable.isSignaled = isSignaled;
  /**
   * Gets the reason for cancelation.
   */
  function getReason(cancelable) {
    if (cancelable === null || cancelable === undefined) return undefined;
    if (!hasInstance(cancelable)) throw new TypeError("Cancelable expected: cancelable");
    if (cancelable === Cancelable.canceled) return canceledReason;
    if (cancelable === Cancelable.none) return undefined;
    return cancelable[Cancelable.cancelSignal]().reason;
  }
  Cancelable.getReason = getReason;
  /**
   * Throws a `CancelError` exception if the provided `cancelable` is in the signaled state.
   */
  function throwIfSignaled(cancelable) {
    var _b;
    if (isSignaled(cancelable)) {
      throw (_b = getReason(cancelable)) !== null && _b !== void 0 ? _b : new CancelError();
    }
  }
  Cancelable.throwIfSignaled = throwIfSignaled;
  /**
   * Subscribes to be notified when a `cancelable` becomes signaled.
   */
  function subscribe(cancelable, onSignaled) {
    if (cancelable === null || cancelable === undefined) return emptySubscription;
    if (!hasInstance(cancelable)) throw new TypeError("Cancelable expected: cancelable");
    if (cancelable === Cancelable.canceled) return onSignaled(), emptySubscription;
    if (cancelable === Cancelable.none) return emptySubscription;
    return cancelable[Cancelable.cancelSignal]().subscribe(onSignaled);
  }
  Cancelable.subscribe = subscribe;
  Cancelable.name = "Cancelable";
  /**
   * Determines whether a value is a `Cancelable` object.
   */
  function hasInstance(value) {
    return (typeof value === "object" && value !== null || typeof value === "function") && Cancelable.cancelSignal in value;
  }
  Cancelable.hasInstance = hasInstance;
})(Cancelable = exports.Cancelable || (exports.Cancelable = {}));
var CancelableSource;
(function (CancelableSource) {
  // #region Cancelable
  CancelableSource.cancelSignal = Cancelable.cancelSignal;
  // #endregion Cancelable
  // #region CancelableSource
  CancelableSource.cancel = Symbol.for("@esfx/cancelable:CancelableSource.cancel");
  // #endregion CancelableSource
  CancelableSource.name = "CancelableSource";
  /**
   * Determines whether a value is a `CancelableSource` object.
   */
  function hasInstance(value) {
    return Cancelable.hasInstance(value) && CancelableSource.cancel in value;
  }
  CancelableSource.hasInstance = hasInstance;
})(CancelableSource = exports.CancelableSource || (exports.CancelableSource = {}));